import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "preview", "signedId", "fileInput"]
  static values = { url: String }

  async fill() {
    const form = this.element.closest("form")
    const title = form.querySelector("[name='book[title]']")?.value?.trim()
    const author = form.querySelector("[name='book[author]']")?.value?.trim()

    if (!title) {
      alert("Please enter a book title first.")
      return
    }

    const btn = this.buttonTarget
    const originalText = btn.textContent
    btn.textContent = "Searching..."
    btn.disabled = true

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({ title, author })
      })

      const data = await response.json()

      if (response.ok) {
        this.signedIdTarget.value = data.signed_id
        this.previewTarget.innerHTML =
          `<div class="mb-4">` +
          `<img src="${data.preview_url}" class="h-48 w-auto object-contain rounded shadow" />` +
          `<p class="text-sm text-gray-500 mt-2">Found cover image</p>` +
          `</div>`

        // Disable file input so it doesn't conflict
        this.fileInputTarget.disabled = true
        this.fileInputTarget.value = ""
      } else {
        alert(data.error || "Failed to find a cover image.")
      }
    } catch (e) {
      alert("Request failed: " + e.message)
    } finally {
      btn.textContent = originalText
      btn.disabled = false
    }
  }
}
